import React, { useState, useEffect } from "react";
import Form from "./components/Form";
import Table from "./components/Table";

function App() {
  const [data, setData] = useState([]);

  // Carregar dados do localStorage ao iniciar
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("cadastros")) || [];
    setData(storedData);
  }, []);

  // Salvar dados no localStorage sempre que a lista mudar
  useEffect(() => {
    localStorage.setItem("cadastros", JSON.stringify(data));
  }, [data]);

  // Adicionar novo registro
  const addEntry = (entry) => {
    setData([...data, entry]);
  };

  // Remover registro individual
  const deleteEntry = (numeroRegistro) => {
    const updatedData = data.filter(
      (item) => item.numeroRegistro !== numeroRegistro
    );
    setData(updatedData);
  };

  // Limpar todos os registros
  const clearAll = () => {
    setData([]);
    localStorage.removeItem("cadastros");
  };

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Cadastro e Lista</h1>
      <Form onAdd={addEntry} />
      <Table data={data} onDelete={deleteEntry} onClearAll={clearAll} />
    </div>
  );
}

export default App;
